import { commonjsGlobal } from '../../_virtual/_commonjsHelpers.js';

var gud;
var hasRequiredGud;

function requireGud () {
	if (hasRequiredGud) return gud;
	hasRequiredGud = 1;

	var key = '__global_unique_id__';

	gud = function() {
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	};
	return gud;
}

export { requireGud as __require };
